import BannerProjects from '../../components/bannerProjects'
import BusinessOtimize from '../../components/businessOtimize'
import OqueE from '../../components/oqueE'
import Rodape from '../../components/rodape'
import SoftwareCards from '../../components/softwareCards'
import SolucoesPerso from '../../components/solucoes-perso'

export default function SoftwareDevelopment() {
  return (
    <>
      <BannerProjects
        backgroundImage="../assets/banner-software-development.png"
        bgMobile="../assets/dev-software-mobile.png"
        title="/DESENVOLVIMENTO"
        titleBold="DE SOFTWARE"
        iconSrc="../assets/icone-projectiva-behub.png"
        iconAlt="Projectiva BeHub"
        iconText="be."
        iconTextBold="hub"
        description="Nossa estratégia de serviços em arquitetura de software é projetada para oferecer soluções de alta qualidade, escaláveis e robustas, que atendam às necessidades específicas de cada cliente."
        footerText="VERTICAL PROJECTS | Development"
        buttonText="Quero me conectar"
        buttonColor="from-[#4B3BDB] to-[#A002CB]"
        brand="behub"
      />
      <OqueE />
      <BusinessOtimize
        backgroundImage="../assets/background_ato.png"
        bgMobile="../assets/bg-purple.png"
        buttonText="Otimize seus negócios"
        buttonTextColor="from-[#A800E4] to-[#A800E4]"
        title={
          <p className="font-inter-light">
            <strong className="font-inter-bold">
              Arquitetos de software altamente qualificados
            </strong>
            , com expertise sólida e conhecimento estratégico de negócios.
          </p>
        }
      />
      <SoftwareCards />
      <SolucoesPerso />
      <Rodape />
    </>
  )
}
